import React from 'react';
import classes from './NavigationToggle.scss';

const navigationToggle = (props) => {

    let barOne = [classes.Bar, classes.Bar__1];
    let barTwo = [classes.Bar, classes.Bar__2];
    let barThree = [classes.Bar, classes.Bar__3];
    
    let styleBarOne = null;
    let styleBarTwo = null;
    let styleBarThree = null;

    if(props.isHeaderNav) {
        barOne.push(classes.BarDark);
        barTwo.push(classes.BarDark);
        barThree.push(classes.BarDark);
    } else {
        barOne.push(classes.BarLight);
        barTwo.push(classes.BarLight);
        barThree.push(classes.BarLight);
    }

    return (
        <div className={classes.Button}>
            <div style={styleBarOne} className={barOne.join(' ')}></div>
            <div style={styleBarTwo} className={barTwo.join(' ')}></div>
            <div style={styleBarThree} className={barThree.join(' ')}></div>
        </div>
    );
}

export default navigationToggle;


// WEBPACK FOOTER //
// ./src/components/UI/NavigationToggle/NavigationToggle.js